
import React from 'react';

import "./Forms.scss";
// add .error to component for error state.

const Select = (props) => {
  const { Options = [], isDisabled = false, Selected, Name } = props
  const disabledClass = isDisabled ? 'disabled' : ''
  return (
    <div className="form-group">
      <div className='form-input'>
        <div className={`form-label ${disabledClass}`}>
          <label htmlFor='text' for={Name}>{props.label}</label>
        </div>
        <div className='form-field'>
          <select id={Name} disabled={isDisabled} value={Selected}
            onChange={props.onChange} name={Name} aria-label={props.label}>
            {Object.values(Options).map(function (option, key) {
              return (
                <option
                  value={Object.keys(Options)[key]}
                  key={key}
                  disabled={Object.keys(Options)[key].length<1}
                >
                  {option}
                </option>)
            })}
          </select>
        </div>
      </div>
    </div>
  )

}
export default Select;
